import { Field, ID, InputType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import { BaseChatMessageArgs } from '../../chat/args/BaseChatMessageArgs'
import type { ChatMessage } from '../../chat/Chat'

/**
 * We just need to extend AddChatMessageArgs to include the information related to the logisticId
 */
@InputType()
export class AddLogisticChatMessageArgs extends BaseChatMessageArgs {
  @Field(() => ID)
  logisticId: string
}

export interface IAddLogisticChatMessage extends IAction<ChatMessage, AddLogisticChatMessageArgs> {}
